import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { SlArrowRight, SlArrowLeft } from "react-icons/sl";

const Container = styled.div`
  margin: 0 auto;
  padding: 60px 40px;
  width: 60%;
  .slick-slide img {
    margin: auto;
    display: block;
    height: 100%;
  }

  @media only screen and (max-width: 1200px){
    padding: 30px 0;
  }
`;

const SlideItem = styled.div`
  //height: 260px;
  padding: 10px;
  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px; // Adds rounded corners to images
  }
`;

const Arrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  //background: black;
  color: white;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
`;

const NextArrow = ({ onClick }) => (
  <Arrow style={{ right: "-60px" }} onClick={onClick}>
    <SlArrowRight size={24} />
  </Arrow>
);

const PrevArrow = ({ onClick }) => (
  <Arrow style={{ left: "-60px" }} onClick={onClick}>
    <SlArrowLeft size={24} />
  </Arrow>
);


function Responsive() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    initialSlide: 0,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Array of image sources for different slides
  const imageSources = [
   './ClientLogos/01.png',
   './ClientLogos/02.png',
   './ClientLogos/03.png',
   './ClientLogos/04.png',
   './ClientLogos/05.png',
   './ClientLogos/06.png',
   './ClientLogos/07.png',
   './ClientLogos/08.png',
   './ClientLogos/09.png',
   './ClientLogos/10.png',
   './ClientLogos/11.png',
   './ClientLogos/12.png',
   './ClientLogos/13.png',
   './ClientLogos/14.png',
   './ClientLogos/16.png',
   './ClientLogos/17.png',
   './ClientLogos/18.png',
   './ClientLogos/19.png',
   './ClientLogos/20.png',
   './ClientLogos/21.png',
   './ClientLogos/22.png',
   './ClientLogos/23.png',
   './ClientLogos/24.png',
   './ClientLogos/25.png',
   './ClientLogos/26.png',
   './ClientLogos/27.png',
   './ClientLogos/28.png',
   './ClientLogos/29.png',
   './ClientLogos/30.png',
   './ClientLogos/31.png',
   './ClientLogos/32.png',
  ];

  return (
    <Container>
      <Slider {...settings}>
        {imageSources.map((src, index) => (
          <SlideItem key={index}>
            <img src={src} alt={`Slide ${index + 1}`} />
          </SlideItem>
        ))}
      </Slider>
    </Container>
  );
}

export default Responsive;
